app.service('stickyHeader', function (_, store, productCardConfig) {

	let $self, $window, $priceBoxes;
	let config, stickyHeaderXhr;

	function init() {
		config = productCardConfig.getData();
		$self = $('#sticky-header');
		$window = $(window);

		loadStickyHeader();
		setEvents();
	}

	function setEvents() {
		store.onChange(loadStickyHeader);
	}

	function setActivePriceBox() {
		$priceBoxes = $self.find('.price-box');
		let $activePriceBox = $priceBoxes.filter(`[data-context=${store.data.isInstalment ? 'instalment' : 'standard'}]`);
		$activePriceBox.addClass('is-active');
		$activePriceBox.not($activePriceBox).removeClass('is-active');
	}

	function loadStickyHeader() {
		$self.addClass('loading');

		if (stickyHeaderXhr) {
			stickyHeaderXhr.abort();
		}

		stickyHeaderXhr = fetchStickyHeader();
		stickyHeaderXhr
			.then(html => {
				render(html);
				setActivePriceBox();
			})
			.fail((jqXHR, textStatus) => {
				if (textStatus === "abort") return;
				$self.text('Błąd ładowania nagłówka.');
			})
			.always(() => {
				$self.removeClass('loading');
			});
	}

	function fetchStickyHeader() {
		return $.ajax({
			url: '/web-cached/product-detail/sticky-header.ltr',
			data: {
				productId: config.id,
				outletCategoryId: store.data.outletCategoryId || undefined,
				instalmentCode: store.data.instalmentCode || undefined,
				instalmentNumber: store.data.instalmentNumber || undefined
			}
		});
	}

	function render(html) {
		$self.html(html);
	}

	return {
		init: init
	}
})